// extracted by mini-css-extract-plugin
var _1 = "CourseStructureTree_tree__68b33";
export { _1 as "tree" }
